import IconAlert from "../../components/elements/IconAlert";

export const operatorColumns = (navigate, setModalConfirm, setModalPdf) => [
    {
        id: "operator",
        name: "OPERATOR",
        minWidth: "240px",
        cell: (row) => (
            <div className="flex items-center gap-3">
                <img
                    src={row.imageProfile || "/images/usrAnonimo.png"}
                    alt={`${row.first_name || ""} ${row.last_name || ""}`}
                    className="w-9 h-9 rounded-full object-cover border border-cs-border"
                />
                <div className="flex flex-col">
                    <span className="text-sm font-semibold text-cs-dark leading-tight">
                        {row.first_name} {row.last_name}
                    </span>
                    <span className="text-[10px] text-cs-muted">
                        ID: {row.id}
                    </span>
                    <span className="text-[10px] text-cs-muted">
                        {row.email}
                    </span>
                </div>
            </div>
        ),
    },
    {
        id: "license",
        name: "DRIVER LICENSE",
        minWidth: "220px",
        cell: (row) => (
            <div className="flex flex-col gap-0.5 text-[10px]">
                <span className="text-cs-muted">
                    Expiration:{" "}
                    <span className="text-cs-dark font-medium">
                        {row.license_expiration || "-"}
                    </span>
                </span>
                <span className="text-cs-muted">
                    {typeof row.license_expiration_days === "number"
                        ? `${row.license_expiration_days} days remaining`
                        : "-"}
                </span>
                <div className="flex items-center gap-2 mt-0.5">
                    {row.driver_license && (
                        <button
                            type="button"
                            onClick={() =>
                                setModalPdf({
                                    show: true,
                                    url: row.driver_license,
                                    title: "Driver License",
                                })
                            }
                            className="text-[10px] text-cs-primary hover:text-cs-primary-hover hover:underline"
                        >
                            View PDF
                        </button>
                    )}
                    <IconAlert
                        days={row.license_expiration_days}
                        textAlert={`${row.first_name || row.name || "Operator"}: Driver License is about to expire!`}
                    />
                </div>
            </div>
        ),
    },
    {
        id: "dot_physical",
        name: "DOT PHYSICAL",
        minWidth: "220px",
        cell: (row) => (
            <div className="flex flex-col gap-0.5 text-[10px]">
                <span className="text-cs-muted">
                    Expiration:{" "}
                    <span className="text-cs-dark font-medium">
                        {row.dot_physical_expiration || "-"}
                    </span>
                </span>
                <span className="text-cs-muted">
                    {typeof row.dot_physical_expiration_days === "number"
                        ? `${row.dot_physical_expiration_days} days remaining`
                        : "-"}
                </span>
                <div className="flex items-center gap-2 mt-0.5">
                    {row.dot_physical_certificate && (
                        <button
                            type="button"
                            onClick={() =>
                                setModalPdf({
                                    show: true,
                                    url: row.dot_physical_certificate,
                                    title: "DOT Physical",
                                })
                            }
                            className="text-[10px] text-cs-primary hover:text-cs-primary-hover hover:underline"
                        >
                            View PDF
                        </button>
                    )}
                    <IconAlert
                        days={row.dot_physical_expiration_days}
                        textAlert={`${row.first_name || row.name || "Operator"}: DOT Physical is about to expire!`}
                    />
                </div>
            </div>
        ),
    },
    {
        id: "status",
        name: "STATUS",
        minWidth: "110px",
        sortable: true,
        cell: (row) => (
            <span
                className={`
                    inline-flex items-center px-2 py-1 rounded-full
                    text-[10px] font-medium
                    ${row.active
                        ? "bg-cs-success/10 text-cs-success"
                        : "bg-cs-danger/10 text-cs-danger"
                    }
                `}
            >
                <span className="w-1.5 h-1.5 rounded-full bg-current mr-1.5" />
                {row.active ? "Active" : "Inactive"}
            </span>
        ),
    },
    {
        id: "actions",
        name: "",
        right: true,
        minWidth: "120px",
        cell: (row) => {
            const canDelete = !!row.can?.delete;

            return (
                <div className="flex items-center justify-end gap-2">
                    {/* Edit */}
                    <button
                        type="button"
                        onClick={() => navigate(`/operator-upadd/${row.id}`)}
                        className="
                            p-1.5 rounded-lg
                            hover:bg-cs-primary-soft
                            text-cs-muted hover:text-cs-primary
                            transition-colors
                        "
                        title="Edit operator"
                    >
                        <span className="material-symbols-outlined text-[18px]">
                            edit
                        </span>
                    </button>

                    {/* Delete */}
                    <button
                        type="button"
                        onClick={() =>
                            canDelete &&
                            setModalConfirm((prev) => ({
                                ...prev,
                                show: true,
                                id: row.id,
                            }))
                        }
                        disabled={!canDelete}
                        className={`
                            p-1.5 rounded-lg transition-colors
                            ${canDelete
                                ? "hover:bg-cs-primary-soft text-cs-danger hover:text-cs-danger"
                                : "opacity-40 cursor-not-allowed text-cs-muted"
                            }
                        `}
                        title="Delete operator"
                    >
                        <span className="material-symbols-outlined text-[18px]">
                            delete
                        </span>
                    </button>
                </div>
            );
        },
    },
];
